import { putMilestone, globalPut } from '../index';

export const editDiscipline = (data) => {
  return globalPut('/discipline', data );
};